import 'magnific-popup';
import { setCookie, getCookie } from './cookies';

const $doc = $(document);

if ($('.bar--subscription').length && !getCookie('subscribe_bar')) {
	$('.bar--subscription').slideDown();

	$('.bar--subscription').on('click', '.bar__close', function(e) {
		e.preventDefault();

		$('.bar--subscription').slideUp();

		setCookie('subscribe_bar', 1, 30);
	});
}

$doc
	.on('click', '.product-item .product-item__quick', function(e) {
		e.preventDefault();
		e.stopPropagation();

		const $this = $(this);
		const url = $this.data('mfp-src');

		$.ajax({
			url: url,
			type: 'GET'
		})
			.done(function(data) {
				const page = $(data)
					.find('.main')
					.html();

				$.magnificPopup.open(
					{
						items: {
							src: page
						},
						type: 'inline',
						mainClass: 'popup-quick-shop',
						modal: true,
						callbacks: {
							open: function() {
								$('.product .product__slider').slick({
									slidesToShow: 1,
									slidesToScroll: 1,
									infinite: true,
									arrows: false,
									dots: false
								});
							}
						}
					},
					0
				);
			})
			.fail(function() {
				console.log('error');
			});
	})
	.on('click', function(event) {
		let $trigger = $('.popup-quick-shop .mfp-content');
		if ($trigger !== event.target && !$trigger.has(event.target).length) {
			$.magnificPopup.close();
		}
	});
